import { useNavigate } from 'react-router-dom';
import type { FlaggedCreator } from '@/utils/dashboard';
import Avatar from '@/components/base/Avatar';
import Badge from '@/components/base/Badge';

export default function CreatorActionsPanel({ creatorActions }: { creatorActions: FlaggedCreator[] }) {
  const navigate = useNavigate();

  return (
    <div className="divide-y divide-background-100">
      {creatorActions.map((action) => (
        <div key={action.id} className="flex items-center gap-3 px-5 py-3">
          <Avatar src={action.avatar} alt={action.creatorName} size="sm" />
          <button
            type="button"
            onClick={() => navigate(`/campaigns/${action.campaignId}?tab=deliverables`)}
            className="min-w-0 flex-1 text-left cursor-pointer"
          >
            <p className="text-sm font-medium text-foreground-950">{action.creatorName}</p>
            <p className="text-xs text-foreground-500 truncate">
              {action.campaign} · {action.action}
            </p>
          </button>
          <div className="flex shrink-0 items-center gap-2">
            <div className="flex flex-col items-end gap-1">
              <Badge tone="primary">{action.flag}</Badge>
              <span className="text-[11px] text-foreground-400">{action.due}</span>
            </div>
            <button
              type="button"
              title={`Pay ${action.creatorName}`}
              aria-label={`Pay ${action.creatorName}`}
              onClick={() => navigate(`/payments/send?creator=${action.creatorId}&find=${encodeURIComponent(action.creatorName)}`)}
              className="flex h-8 w-8 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-700 cursor-pointer transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              <i className="ri-send-plane-line" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}